import React from 'react';

import Table from '../../../../components/Table';
import Header from '../../../../components/Table/Header';
import Cell from '../../../../components/Cell';

import { I18n } from 'react-redux-i18n';

class RawTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { data } = this.props;
    const columns = [
      {
        Header: () => (
          <Header
            title={I18n.t('negoce.raw.saleYear')}
            styles={`justify-content:flex-start;padding-left:30px`}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb; justify-content:flex-start;padding-left:30px`}
          />
        ),
        maxWidth: 150,
        accessor: 'sale_year',
        name: I18n.t('negoce.raw.saleYear')
      },
      {
        Header: () => <Header title={I18n.t('negoce.raw.saleTypeName')} />,
        Cell: (props) => (
          <Cell
            {...props}
            font="sfcompact_text"
            styles={`border-right: 1px solid #e8e9eb`}
          >
            {props.value}
          </Cell>
        ),
        maxWidth: 150,
        accessor: 'sale_type_name',
        name: I18n.t('negoce.raw.saleTypeName')
      },
      {
        Header: () => <Header title={I18n.t('negoce.raw.wineName')} />,
        Cell: (props) => (
          <Cell {...props} styles={`border-right: 1px solid #e8e9eb`}>
            {props.value}
          </Cell>
        ),
        accessor: 'wine_name',
        name: I18n.t('negoce.raw.wineName')
      },
      {
        Header: () => <Header title={I18n.t('negoce.raw.vintage')} />,
        Cell: (props) => (
          <Cell
            {...props}
            font="sfcompact_text"
            styles={`border-right: 1px solid #e8e9eb`}
          >
            {props.value}
          </Cell>
        ),
        maxWidth: 100,
        accessor: 'vintage',
        name: I18n.t('negoce.raw.vintage')
      },
      {
        Header: () => <Header title={I18n.t('negoce.raw.negociantName')} />,
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'negociant_name',
        name: I18n.t('negoce.raw.negociantName')
      },
      {
        Header: () => <Header title={I18n.t('negoce.raw.customerName')} />,
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'customer_name',
        name: I18n.t('negoce.raw.customerName')
      },
      {
        Header: () => <Header title={I18n.t('negoce.raw.countryName')} />,
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'country_name',
        name: I18n.t('negoce.raw.countryName')
      },
      {
        Header: () => <Header title={I18n.t('negoce.raw.quantityEq75')} />,
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'quantity_eq_75',
        name: I18n.t('negoce.raw.quantityEq75')
      }
    ].filter((item) => item !== false);

    return <Table columns={columns} data={data} expanded />;
  }
}

export default RawTable;
